import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [{
  path: '/',
  name: 'Home',
  component: Home,
},
{
  path: '/about',
  name: 'About',
  component: () =>
    import ('../views/About.vue'),
},
{
  path: '/bmw',
  name: 'BMW',
  component: () =>
    import ('../views/Bmw.vue'),
},
{
  path: '/mini',
  name: 'MINI',
  component: () =>
    import ('../views/Mini.vue'),
},
]

const router = createRouter({
  history: createWebHistory(),
  //history:createWebHashHistory(),
  routes,
})

export default router